import { getDocumentTypeList } from '@/api/documentType'
import StrUtils from '@/utils/StrUtils'
import $store from '@/store'
import lang from '@/lang'

export class DocumentTypeUtil {
  static instance

  constructor() {
    this._map = {}
  }
  get map() {
    return this._map
  }

  set map(value) {
    this._map = value
  }

  static async getInstance() {
    if (!this.instance) {
      this.instance = new DocumentTypeUtil()
      await getDocumentTypeList({ pageNum: 1, pageSize: 1000000 }).then((res) => {
        this.buildMap(res.data.list)
      })
    }
    return this.instance
  }

  static buildMap(source) {
    if (!source) return
    source.forEach(obj => {
      this.instance._map[obj.code] = obj
    })
  }

  fileTypeLabelFunction(value) {
    if (StrUtils.isEmpty(value)) return ''
    const language = $store.getters.language === 'zh' ? 'name' : 'localName'
    const codes = value.split(',')
    const label = []
    for (const code of codes) {
      if (this._map.hasOwnProperty(code)) {
        const name = this._map[code][language]
        if (!StrUtils.isEmpty(name)) {
          label.push(name)
        }
      }
    }
    if (label.length > 0) {
      return label.join(',')
    }
    return lang.t('Message.Other')
  }
}
